import { DynamicComponentBlok } from '@customTypes/storyblok-types';
import React from 'react';
import { StoryblokComponent } from '@storyblok/react';

const DynamicComponent: React.FC<{ blok: DynamicComponentBlok }> = ({ blok }) => {
  return <StoryblokComponent blok={blok} />;
};

export default DynamicComponent;
